module.exports = __webpack_public_path__ + "img/ceef446.jpg";